export enum ActionType {
  KEYED = 'keyed',
  SWIPE = 'swipe'
}
